import PricingTwo from "./PricingTwo";

export default PricingTwo
